import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, share } from 'rxjs/operators';
import { UpdateOperations } from './update-operations';
import {
  ProjectionFilter,
  GetMultiListingProfileRequest,
  ListingProfileApiService as ApiService,
  UpdateListingProfileRequest,
  ListingProfile,
} from '@vendasta/listing-products';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ListingProfileService {
  constructor(
    private lp: ApiService,
    private translate: TranslateService,
  ) {}

  get(businessId: string, projectionFilter: ProjectionFilter): Observable<ListingProfile> {
    return this.lp
      .getMulti(
        new GetMultiListingProfileRequest({
          businessIds: [businessId],
          projectionFilter: projectionFilter,
          languageCode: this.translate.currentLang || this.translate.defaultLang,
        }),
      )
      .pipe(
        map((response) => {
          return response?.listingProfiles?.length > 0 ? response.listingProfiles[0].listingProfile : null;
        }),
        share(),
      );
  }

  bulkUpdate(businessId: string, updateOperations: UpdateOperations): Observable<HttpResponse<null>> {
    return this.lp
      .update(
        new UpdateListingProfileRequest({
          businessId: businessId,
          updateOperations: updateOperations.toApiJson(),
        }),
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          let message;
          if (err.status === 401) {
            message = this.translate.instant('FRONTEND.BUSINESSES.INVALID_SESSION');
          } else if (err.status === 400) {
            message =
              (err.error && err.error.message) || this.translate.instant('FRONTEND.BUSINESSES.INVALID_SUBMISSION');
          } else {
            message = this.translate.instant('FRONTEND.BUSINESSES.FAILED_TO_UPDATE');
          }
          return observableThrowError({ message: message, retryable: err.status === 401 });
        }),
        share(),
      );
  }
}
